// extracted by mini-css-extract-plugin
module.exports = {"table":"Table_table__gv3mf","tableInner":"Table_tableInner__HMQJs typography_body__vVxn5"};